<template>

	<widget :widget-spinner="!reviewableLogsFetched"
			  :max-height="maxHeight"
			  title="Your Review Items">

		<div class="d-flex flex-wrap items-grid">

			<div class="" v-if="numTimeLogsToReview > 0">
				<router-link to="/time-logs/review"  class="review-item-panel">
					<h3>Time Logs to Review:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numTimeLogsToReview }}</div>
						<i class="fa fa-clock"></i>
					</div>
				</router-link>
			</div>
			<div class=" review-item-panel" v-if="numCompanyFormsToReview > 0">
				<div class="">
					<h3>Forms to Sign:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numCompanyFormsToReview }}</div>
						<i class="fa fa-pencil-square-o"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light mr-1" v-on:click="viewCompanyForms">View</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numLocatesToReview > 0">
				<div class="review-item-panel">
					<h3>Locate Tickets to Review:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numLocatesToReview }}</div>
						<i class="fa fa-map-pin"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light" v-on:click="viewLocates">View</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numExpensesToReview > 0">
				<router-link to="/expenses/review" class="review-item-panel">
					<h3>Expenses to Review:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numExpensesToReview }}</div>
						<i class="fa fa-money-bill"></i>
					</div>
				</router-link>
			</div>
			<div class="" v-if="numServicesIncomplete > 0 && hasModulePermWrite('Services')">
				<div class="review-item-panel">
					<h3>Incomplete Services:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numServicesIncomplete }}</div>
						<i class="fa fa-wrench"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light" v-on:click="viewIncompleteServices">View</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numServicesArchivable > 0 && hasModulePermWrite('Services')">
				<div class="review-item-panel">
					<h3>Archivable Services:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numServicesArchivable }}</div>
						<i class="fa fa-wrench"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light mr-1" v-on:click="viewServices">View</button>
						<button class="btn btn-light" v-on:click="archiveAllServices">Archive All</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numProjectsArchivable > 0 && hasModulePermWrite('Jobs')" >
				<div class="review-item-panel">
					<h3>Archivable Projects:</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numProjectsArchivable }}</div>
						<i class="fa fa-wrench"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light mr-1" v-on:click="viewProjects">View</button>
						<button class="btn btn-light" v-on:click="archiveAllProjects">Archive All</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numUnseenInvoices > 0 && (hasModulePermWrite('Service Quotes/Invoices') || hasModulePermWrite('Job Invoices'))">
				<div class="review-item-panel">
					<h3>Invoices Unopened by Customers<div><small>(older than {{ unseenDays }} days)</small></div></h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numUnseenInvoices }}</div>
						<i class="fa fa-fw fa-file-invoice-dollar"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light mr-1" v-on:click="viewUnseenInvoices">View</button>
					</div>
				</div>
			</div>
			<div class="" v-if="numVacationRequests > 0 && hasModulePermWrite('Schedule')" >
				<div class="review-item-panel">
					<h3>Vacation Requests</h3>
					<div class="d-flex justify-content-between align-items-center">
						<div class="total">{{ numVacationRequests }}</div>
						<i class="fa fa-fw fa-calendar-alt"></i>
					</div>
					<div class="d-flex justify-content-end">
						<button class="btn btn-light mr-1" v-on:click="viewVacationRequests">View</button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="numExpensesToReview == 0 && numLocatesToReview == 0 && numTimeLogsToReview == 0 && numCompanyFormsToReview == 0 && numProjectsArchivable == 0 && (numServicesArchivable == 0 || !hasModulePermWrite('Services')) && reviewableLogsFetched" class="text-center">

			<div class="d-flex flex-row justify-content-center">
				<div class="mr-3">
					<i class="fa fa-2x fa-check-circle text-success"></i>
				</div>
				<div>
					<h3>You're all good!</h3>
					<p>Nothing to review</p>
				</div>
			</div>
		</div>


		<!-- Company Forms Modal -->

		<modal-dialog
			:modal-visible="companyFormsModalVisible"
			title="Company Form Invitations"
			modal-size="modal-lg"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="companyFormsModalVisible = false">

			<table-list
				record-name="Company Form"
				:fields="[
					{ label: 'Form Description', key: 'formDescription' },
					{ label: 'Project/Service',  key: 'jobNum', type: 'external-link' },
					{ label: 'Equipment',        key: 'equipmentDescription' }
				]"
				:records="mutatedCompanyForms"
				:sortable="true"
				:loading="companyFormsLoading"
				:has-edit="true"
				edit-button-text="Open"
				v-on:edit="doCompanyForm">

			</table-list>

		</modal-dialog>
		

		<!-- Locates Modal -->

		<modal-dialog
			:modal-visible="locatesModalVisible"
			title="Locates Expiring in the Next 5 Days"
			modal-size="modal-lg"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="locatesModalVisible = false">

			<table-list
				record-name="Locate"
				has-edit="locates/"
				id-field="ticket_num"
				edit-button-text="View"
				edit-button-icon="fa-eye"
				:other-buttons="[
				{
					class: 'btn-light',
					click: 'openMarkLocateModal',
					icon: 'fa-marker',
					title: 'Mark',
					text: 'Mark'
				}
				]"
				v-on:otherButtonClick="otherButtonClick"
				:fields="[
					{label: 'Ticket #', key: 'ticket_num'},
					{label: 'Project/Service',key:'jobName'},
					{label: 'Expiry Date',key:'fullExpiryDate'},
					{label: 'Refresh Date',key:'refresh_date'},
					{label: 'Action',key:'fullAction',align:'center'},
				]"
				:records="mutatedLocates"
				:sortable="true">

			</table-list>

		</modal-dialog>

		<!-- Mark Locates Modal -->

		<modal-dialog
			class="text-center"
			:modal-visible="markLocateModal.isVisible"
			title="Mark Locate"
			:submit-visible="true"
			cancel-button-text="Close"
			v-on:confirm="saveLocateMark"
			v-on:closeModal="markLocateModal.isVisible = false">

			<h3>Please select an action tag for this locate</h3>

			<button-group
				:value="markLocateModal.action"
				v-on:change="changeLocateAction"
				:buttons="[
					{value: 'Refresh', text: 'Refresh'},
					{value: 'Hold', text: 'Hold'},
					{value: 'Close', text: 'Close'}
			]">
			</button-group>

		</modal-dialog>


		<!-- Archive Services Modal -->

		<modal-dialog
			:modal-visible="serviceListModalVisible"
			title="Archivable Services"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="serviceListModalVisible = false">

			<p>Archivable services are services that have been invoiced and haven't been clocked into for greater than 30 days</p>

			<table-list record-name="Service"
				:has-edit="true"
				edit-button-text="Archive"
				edit-button-icon="fa-archive"
				:fields="[
					{label: 'Service #',key:'jobNum',type:'link'},
					{label: 'Service Name',key:'job_name'},
					{label: 'Status',key:'status'},
					//{label: 'Last Time Log',key:lastTimelog}
				]"
				:records="mutatedArchivableServices"
				v-on:edit="archiveService">

				<button class="btn btn-success" v-on:click="archiveAllServices">
					<i class="fa fa-archive"></i>
					Archive All
				</button>

			</table-list>

		</modal-dialog>


		<!-- Archivable Projects Modal -->

		<modal-dialog
			:modal-visible="projectsListModalVisible"
			title="Archivable Projects"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="projectsListModalVisible = false">

			<p>Archivable projects are projects that have been marked as complete for greater than 60 days</p>

			<table-list record-name="Project"
				:has-edit="true"
				edit-button-text="Archive"
				edit-button-icon="fa-archive"
				:fields="[
					{label: 'Project #',key:'jobNum',type:'link'},
					{label: 'Project Name',key:'job_name'},
					{label: 'Completed',key:'date_completed'},
					//{label: 'Last Time Log',key:lastTimelog}
				]"
				:records="mutatedArchivableProjects"
				v-on:edit="archiveProject">

				<button class="btn btn-success" v-on:click="archiveAllProjects">
					<i class="fa fa-archive"></i>
					Archive All
				</button>

			</table-list>

		</modal-dialog>


		<!----- Incomplete Services Modal ----->
		<modal-dialog
			:modal-visible="incompleteServicesModal.visible"
			title="Incomplete Services"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="incompleteServicesModal.visible = false">

			<p>These are services that have been marked as "Incomplete"</p>

			<table-list
				v-if="!incompleteServicesModal.service"
				record-name="Service"
				:fields="[
					{label: 'Service #',    key:'jobNum', type:'link'},
					{label: 'Service Name', key:'job_name'},
					{label: 'Status',       key:'status'}
				]"
				:records="mutatedIncompleteServices"
				:other-buttons="[
					{
						class: 'btn-light',
						click: 'openNotes',
						icon: 'fa-pen',
						text: 'View Notes',
						condition: ['hasInternalNotes', true]
					}
				]"
				v-on:openNotes="openIncompleteServiceNotes">
			</table-list>

			<div v-else class="card p-3">
				<div class="d-flex justify-content-between mb-2">
					<router-link :to="incompleteServicesModal.service.jobNum.link">
						#{{incompleteServicesModal.service.job_num}}: {{incompleteServicesModal.service.job_name}}
					</router-link>

					<i class="fa fa-times icon-button close-button" v-on:click="incompleteServicesModal.service = null"></i>
				</div>

				<span class="text-danger mb-2">{{incompleteServicesModal.service.status}}</span>

				{{incompleteServicesModal.service.internal_notes}}
			</div>

		</modal-dialog>


		<!----- Unseen Invoices Modal ----->
		<modal-dialog
			:modal-visible="unseenInvoicesModal.visible"
			:title="'Invoices Unopened by Customer for ' + unseenDays + ' days'"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="unseenInvoicesModal.visible = false">

			<p>These are invoices that have been sent to customers, but haven't been opened by them in {{ unseenDays }} days or longer. You may consider following up manually.</p>

			<template>

				<table-list record-name="Invoice"
					:fields="[
						{label: 'Invoice #',key:'invoiceNum',type:'link'},
						{label: 'Customer',key:'customerName'},
						{label: 'First Issued',key:'firstIssued'}
					]"
					:loading="unseenInvoicesModal.spinner"
					:records="mutatedInvoices">
				</table-list>

			</template>

		</modal-dialog>

		<modal-dialog
			:modal-visible="vacationRequestsModal.visible"
			title="Vacation Requests"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="vacationRequestsModal.visible = false">

			<p>These are vacation requests that have not yet been addressed:</p>

			<table-list record-name="Vacation Request"
				:fields="[
					{label: 'Employee', key: 'userFullName'},
					{label: 'Note', key: 'notes'},
					{label: 'From', key: 'startTimeFormatted'},
					{label: 'Until', key: 'endTimeFormatted'}
				]"
				:other-buttons="[
					{
						text: 'Apr',
						click: 'approveVacation',
						icon: 'fa-check',
						class: 'btn-primary',
						title: 'Approve vacation request'
					},
					{
						text: 'Reject',
						click: 'rejectVacation',
						icon: 'fa-check',
						class: 'btn-dark',
						title: 'Reject vacation request'
					}
				]"
				:records="mutatedVacationRequests"
				:loading="vacationRequestsModal.spinner"
				v-on:approveVacation="approveVacation"
				v-on:rejectVacation="rejectVacation">
			</table-list>

		</modal-dialog>

	</widget>

</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import ButtonGroup from "@/components/ButtonGroup"

export default {
	name: "ReviewItemsWidget",
	components: {
		ButtonGroup,
		ModalDialog,
		Widget,
		TableList
	},
	props: ["maxHeight"],
	data() {
		return {
			numTimeLogsToReview: 0,
			numExpensesToReview: 0,
			numCompanyFormsToReview: 0,
			//numLocatesToReview: 0,	Now a computed variable
			numServicesArchivable: 0,
			numProjectsArchivable: 0,
			numServicesIncomplete: 0,
			numVacationRequests: 0,
			numUnseenInvoices: 0,
			unseenDays: 4,
			companyForms: [],
			ticketIDs: [],
			ticketsToReview: [],
			mutatedLocates: [],
			archivableServices: [],
			archivableProjects: [],
			incompleteServices: [],
			unseenInvoices: [],
			vacationRequests: [],
			reviewableLogsFetched: false,
			//modalDialogVisible: false,
			companyFormsModalVisible: false,
			locatesModalVisible: false,
			serviceListModalVisible: false,
			projectsListModalVisible: false,
			unseenInvoicesModal: {
				visible:  false,
				spinner: false
			},
			companyFormsLoading: false,
			markLocateModal: {			// Change mark status of locate
				isVisible: false,
				action: "",
				locate_id: ""
			},
			incompleteServicesModal: {
				visible: false,
				service: null
			},
			vacationRequestsModal: {
				visible: false,
				spinner: false
			}
		}
	},
	computed: {

		mutatedCompanyForms() {
			return this.companyForms.map(ack => {

				let form = ack.CompanyForm   // shorthand for clarity
				
				
				ack.formDescription = ""

				if ('FormChildTemplate' in form && form.FormChildTemplate) {
					if ('description' in form.FormChildTemplate && form.FormChildTemplate.description)
						ack.formDescription = form.FormChildTemplate.description
				}



				ack.jobNum = { text:"", link:"" }

				if ('Job' in form && form.Job) {
					if ('job_num' in form.Job && form.Job.job_num) {
						ack.jobNum.text = "Project #" + form.Job.job_num
						ack.jobNum.link = "/project/" + form.Job.slug + "/dashboard"
					}
				}

				else if ('Service' in form && form.Service) {
					if ('job_num' in form.Service && form.Service.job_num) {
						ack.jobNum.text = "Service #" + form.Service.job_num
						ack.jobNum.link = "/service/" + form.Service.slug+"/dashboard"
					}
				}


				ack.equipmentDescription = ""

				if ('Equipment' in form && form.Equipment) {
					if ('description' in form.Equipment && form.Equipment.description)
						ack.equipmentDescription = form.Equipment.description
				}


				return ack
			})
		},

		numLocatesToReview() {
			return this.ticketsToReview.filter(ticket => {
				return (ticket.action == "") ||
					(ticket.action == "Hold" && ticket.action_last_updated < this.moment().subtract(2,"weeks").format("YYYY-MM-DD HH:mm:ss"))
			}).length
		},

		mutatedIncompleteServices() {
			return this.incompleteServices.map(service => {
				service.hasInternalNotes = service.internal_notes && service.internal_notes != ""
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},

		mutatedArchivableProjects() {
			this.numProjectsArchivable

			return this.archivableProjects.map(job => {
				job.jobNum = {
					text: job.job_num,
					link: "/service/"+job.slug+"/dashboard"
				}

				return job
			})
		},
		mutatedArchivableServices() {
			if (!this.archivableServices)
				return []

			console.log(this.archivableServices)

			return this.archivableServices.map(service => {
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},
		mutatedInvoices() {
			let vm = this
			return this.unseenInvoices.map(inv => {

				let text = "", link = ""

				if ("Service" in inv && inv.Service) {
					text = inv.Service.job_num
					link = "/service/"+inv.Service.slug+"/invoice"
				}	
				else if ("Job" in inv && inv.Job) {
					text = inv.Job.job_num + "-" + inv.invoice_num
					link = "/project/"+inv.Job.slug+"/billing/"+inv.slug
				}
				else {
					text = inv.standalone_num
					link = "/invoice/"+inv.slug+"/details"
				}

				inv.invoiceNum = {
					text,
					link
				}

				inv.customerName = ""
				if ("Customer" in inv && inv.Customer)
					inv.customerName = inv.Customer.name
				else if ("Job" in inv && inv.Job && "Customer" in inv.Job && inv.Job.Customer)
					inv.customerName = inv.Job.Customer.name
				else if ("Job" in inv && inv.Job && "customer_name_cache" in inv.Job)
					inv.customerName = inv.Job.customer_name_cache
				else if ("Service" in inv && inv.Service && "customer_name_cache" in inv.Service)
					inv.customerName = inv.Service.customer_name_cache

				inv.firstIssued = vm.formatDate(inv.date_first_issued)

				return inv
			})
		},
		mutatedVacationRequests() {
			let vm = this

			return this.vacationRequests.map(event => {
				event.userFullName = event.User.first_name + " " + event.User.last_name

				event.startTimeFormatted = vm.formatDateTimeToLocal(event.start_time)
				event.endTimeFormatted = vm.formatDateTimeToLocal(event.end_time)

				return event
			})
		}
	},
	methods: {
		openIncompleteServiceNotes(item) {
			this.incompleteServicesModal.service = item
		},
		doCompanyForm(ackRecord) {
			let formLink = "/form/external/"+ackRecord.CompanyForm.slug+"/"+ackRecord.slug
			window.open(formLink, '_blank');
		},
		mutateLocates() {
			let vm = this

			this.mutatedLocates = this.ticketsToReview.map(ticket => {

				// Use the first locate in the ticket as a reference
				// for repeating member values
				let locate = ticket.Locate[0]

				let copyKeys = ['status', 'expiry_date', 'refresh_date']
				copyKeys.forEach(key => {
					ticket[key] = locate[key]
				})

				ticket.Locate.forEach(locate => {

					if (locate.expiry_date < ticket.expiry_date)
						ticket.expiry_date = locate.expiry_date

					if (locate.refresh_date < ticket.refresh_date)
						ticket.refresh_date = locate.refresh_date
				})

				if (ticket.expiry_date < this.moment().format("YYYY-MM-DD"))
					ticket.fullExpiryDate = "<span class='text-danger'>" + ticket.expiry_date + "</span>"
				else
					ticket.fullExpiryDate = ticket.expiry_date

				if ('Job' in ticket && ticket.Job)
					ticket.jobName = ticket.Job.job_name
				else if ('Service' in ticket && ticket.Service)
					ticket.jobName = ticket.Service.job_name
				else
					ticket.jobName = ""

				let actionIcon = ""
				let actionColor = ""

				if (ticket.action == 'Refresh') {
					actionIcon = "fa fa-sync"
					actionColor = "text-success"
				} else if (ticket.action == 'Hold') {
					actionIcon = "fa fa-pause-circle"
					actionColor = "text-warning"
				} else if (ticket.action == 'Close') {
					actionIcon = "fa fa-times-circle"
					actionColor = "text-danger"
				}

				ticket.fullAction = "<i class='" + actionIcon + " " + actionColor + "'>"
				return ticket

			})
			.sort((a,b) => {
				return (a.expiry_date < b.expiry_date) ? -1 : 1
			})
		},
		changeLocateAction(action) {
			this.markLocateModal.action = action
		},
		openMarkLocateModal(ticket) {
			this.markLocateModal.ticket_id = ticket.id

			if ('action' in ticket)
				this.markLocateModal.action = ticket.action

			this.markLocateModal.isVisible = true
		},
		otherButtonClick(record,action) {
			this[action](record);
		},
		saveLocateMark() {
			let vm = this

			let payload = {
				id: vm.markLocateModal.ticket_id,
				action: vm.markLocateModal.action
			}

			this.postData("LocateTicket/save", payload,true).then(response => {
				if (response.success){
					// Success? Find locate in list and update action directly
					let ticket = vm.ticketsToReview.find(ticket => ticket.id == vm.markLocateModal.ticket_id)
					ticket.action = vm.markLocateModal.action
					ticket.action_last_updated = vm.moment().utc().format("YYYY-MM-DD HH:mm:ss")
					vm.mutateLocates()

					// Reset modal
					vm.markLocateModal.isVisible = false
					vm.markLocateModal.ticket_id = ""
					vm.markLocateModal.action = ""
				}
			})
		},
		viewUnseenInvoices() {
			this.unseenInvoicesModal.visible = true
			this.fetchUnopenedInvoices(false)
		},
		viewVacationRequests() {
			let vm = this

			this.vacationRequestsModal.visible = true
		},
		approveVacation(event) {
			let vm = this

			let payload = {
				approved: 1,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		rejectVacation(event) {
			let vm = this

			let payload = {
				approved: 0,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		archiveAllProjects() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableProjects.map(project => {
					return {
						id: project.id,
						archived: 1
					}
				}))
			}

			this.postData("Job/save-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" projects archived!")
					vm.fetchArchivableProjects()
				}
			})
		},
		archiveAllServices() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableServices.map(service => {
					return {
						id: service.id,
						archived: 1
					}
				}))
			}

			this.postData("Service/archive-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" services archived!")
					vm.fetchArchiveableServices()
				}
			})
		},
		archiveProject(project,index) {
			let vm = this

			this.postData("Job/save",{id:project.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableProjects.findIndex(theProject => theProject.id == project.id)

					if (index){
						vm.archivableProjects.splice(index,1)
						vm.numProjectsArchivable--
					}
				}
			})
		},
		archiveService(service,index) {
			let vm = this

			this.postData("Service/save",{id:service.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableServices.findIndex(theService => theService.id == service.id)

					if (index >= 0){
						vm.archivableServices.splice(index,1)
						vm.numServicesArchivable--
					}
				}
			})
		},
		viewIncompleteServices() {
			this.incompleteServicesModal.service = null
			this.incompleteServicesModal.visible = true
		},
		viewProjects() {
			this.projectsListModalVisible = true
		},
		viewServices() {
			this.serviceListModalVisible = true
		},
		viewCompanyForms() {
			if (!this.companyForms.length)
				this.fetchCompanyForms(true)

			this.companyFormsModalVisible = true
		},
		viewLocates() {
			this.locatesModalVisible = true
		},
		fetchLocateTickets() {
			let vm = this
			vm.spinner(true)

			let include = [
				{
					model: "Locate",
					fields: ["expiry_date", "refresh_date"]
				},
				{
					model: "Job",
					fields: ["job_name"]
				},
				{
					model: "Service",
					fields: ["job_name"]
				}
			]

			let expiryDate = this.moment().add(5,"days").format("YYYY-MM-DD")

			let paramsExpired = {
				filters: [
					["archived", 0],
					["action", 	""],
					["Locate",  true],
					["Locate.expiry_date",   true],
					["Locate.expiry_date <", expiryDate]
				],
				include: include
			}

			let paramsHold = {
				filters: [
					["archived", 0],
					["Locate",   true],
					["action", "Hold"],
					["action_last_updated", true],
					["action_last_updated <", this.moment().subtract(7,"days").format("YYYY-MM-DD HH:mm:ss")]
				],
				include: include
			}

			let promises = [
				this.getJSON("LocateTicket/mine", paramsExpired),
				this.getJSON("LocateTicket/mine", paramsHold)
			]

			Promise.all(promises).then(responses => {

				vm.spinner(false)
				//vm.ticketsToReview = responses[0].data.concat(responses[1].data)
				let fetchedTickets = responses[0].data.concat(responses[1].data)

				let tickets = []
				let ticketIDs = []

				fetchedTickets.forEach(ticket => {
					ticket.Locate = ticket.Locate.filter(locate => {
						return locate.expiry_date && locate.expiry_date < expiryDate
					})

					// Unique and contains locates
					if (!ticketIDs.includes(ticket.id) && ticket.Locate.length > 0) {
						ticketIDs.push(ticket.id)
						tickets.push(ticket)
					}
				})

				vm.ticketsToReview = tickets
				vm.mutateLocates()
			})

		},
		fetchUnopenedInvoices(count) {
			let vm = this

			let sinceDays = this.unseenDays

			let baseFilters = [
				["date_first_issued <=",this.moment().subtract(sinceDays,"days").format("YYYY-MM-DD")],
				["seen_log_json",""],
				["is_paid",0],
				["last_emailed >","0000-00-00"]
			]

			let fields = ["Customer","Service","Job","id","slug","standalone_num","invoice_num","date_first_issued"]

			let include = []

			if (!count) {
				include = [
					{
						model: "Contact",
						fields: ["name"]
					},
					{
						model: "Job",
						fields: ["slug","job_num","job_name","Customer"],
						include: ["Contact"]
					},
					{
						model: "Service",
						fields: ["slug","job_num","job_name"]
					}
				]

				vm.unseenInvoicesModal.spinner = true
			}

			let promises = [
				vm.getJSON("ServiceInvoice/get",{
					filters: [
						["finalized",1],
						["is_quote",0],
						...baseFilters
					],
					include,
					count,
					fields
				}),
				vm.getJSON("JobInvoice/get",{
					filters: [
						["is_finalized",1],
						["is_active_version",1],
						...baseFilters
					],
					include,
					count,
					fields
				})
			]

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					
					if (count) {
						vm.numUnseenInvoices = 0

						responses.forEach(response => {
							if (response.success)
								vm.numUnseenInvoices += response.count
						})
					}
					else {
						vm.unseenInvoices = [
							...responses[0].data,
							...responses[1].data
						]
					}

					vm.unseenInvoicesModal.spinner = false

					resolve(responses)

				})
			})
		},
		fetchIncompleteServices() {
			let vm = this

			const params = {
				fields: ['id', 'slug', 'status', 'job_num', 'job_name', 'internal_notes'],
				filters: [
					['archived', 0],
					['status', 'Incomplete', 'and', 'like']
				]
			}

			this.getJSON('Service/get', params).then(response => {
				if (response.success) {
					vm.incompleteServices = response.data
					vm.numServicesIncomplete = response.data.length
				}
			})
		},
		fetchArchiveableServices() {
			let vm = this

			let params = {
				filters: [
					["archived",0],
					["status", "Invoiced"],
					["TimeLog.time_out <",this.moment().subtract(30,"days").format("YYYY-MM-DD")],
					["archived",0,'or'],
					["status", "Canceled"],
				],
				include: [{
					model:"TimeLog",
					fields:["id","time_out"],
					orders: [
						["time_out","DESC"]
					],
					limit: 1
				}],
				fields: ["id","slug","job_name","job_num"]
			}

			this.getJSON("Service/archivable-services").then(response => {
				if (response.success) {
					vm.archivableServices = response.data
					vm.numServicesArchivable = response.data.length
				}
			})
		},
		fetchCompanyForms(fetchAll=false) {
			let vm = this

			// Make sure the widget modal shows that its loading
			this.companyFormsLoading = true

			let params = {
				filters: [
					['user_id', this.$store.userDetails.id],
					['completed_at', null],
					['CompanyForm.deleted',0]
				]
			}

			if (!fetchAll) {
				params.fields = []
				params.include = [{model: "CompanyForm",fields:["deleted"]}]
			} else {
				params.fields = ['form_id']
				params.include = [
					"UserToken",
					{
						model: 'CompanyForm',
						fields: ['expiry', 'child_template_id', 'job_id', 'service_id', 'equipment_id','deleted'],
						include: [
							{ model: 'FormChildTemplate', fields: ['description'] },
							{ model: 'Job',               fields: ['job_num'] },
							{ model: 'Service',           fields: ['job_num'] },
							{ model: 'Equipment',         fields: ['description'] },
						]
					}
				]
			}

			this.getJSON('CompanyFormAcknowledgement/get', params).then(response => {
				if (response.success) {
					vm.numCompanyFormsToReview = response.data.length

					if (fetchAll)
						vm.companyForms = response.data
				}

				vm.companyFormsLoading = false
			})
		},
		fetchVacationRequests() {
			let vm = this

			let params = {
				filters: [
					["is_vacation",1],
					["approved_by",0],
					["rejected_by",0],
					["start_time >",this.moment().format("YYYY-MM-DD")]
				],
				fields: [
					"user_id","is_vacation","start_time","end_time","approved_by","rejected_by","notes"
				],
				include: [{
					model: "User",
					fields: ["first_name","last_name"]
				}]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					vm.vacationRequests = response.data
					vm.numVacationRequests = response.data.length
				}
			})
		},
		fetchArchivableProjects() {
			let vm = this

			let params = {
				filters: [
					["date_completed <",this.moment().subtract(60,"days").format("YYYY-MM-DD")],
					["archived",0]
				],
				fields: ["id","slug","job_num","job_name","date_completed"]
			}

			this.getJSON("Job/get",params).then(response => {
				if (response.success) {
					vm.archivableProjects = response.data
					vm.numProjectsArchivable = response.data.length
				}
			})
		},
		/*
		* This is the original function which only uses standard API endpoints
		*/
		/*fetchReviewableLogs() {
			let vm = this

			//get list of projects/services this user manages
			let jobInclude = [
				{
					model:"TimeLog",
					fields: ["job_id","service_id","time_out","reviewed_by"],
					include:[
						{
							model:"User",
							fields:["id","slug"],
							include:[
								{model:"EmployeeSetting",fields:["is_salary"]}
							]
						}
					]
				}
			]

			let params = {
				filters: [
					["user_id",this.$store.userDetails.id],
					["JobPersonnelRole.review_timelogs",1]
				],
				include: [
					{model: "JobPersonnelRole",fields: ["id","review_timelogs","review_expenses"]},
					{model: "Service",
						fields: ["id","slug","job_name","job_num","TimeLog"],
						include: jobInclude
					},
					{model: "Job",
						fields: ["id","slug","job_name","job_num","TimeLog"],
						include: jobInclude
					}
				]
			}

			let promises = [
				this.getJSON("JobUser/get",params),
				this.getJSON("ServiceUser/get",params)
			]

			Promise.all(promises).then(responses => {

				vm.numTimeLogsToReview = false

				responses[0].data.forEach(item => {

					item.Job.TimeLog.forEach(log => {
						if (log.reviewed_by == 0 && log.time_out != '0000-00-00 00:00:00') {
							if (!("EmployeeSetting" in log.User) || log.User.EmployeeSetting.length == 0 || log.User.EmployeeSetting[0].is_salary == 0) {
								vm.numTimeLogsToReview++
							}
						}
					})
				})

				responses[1].data.map(item => {
					item.Service.TimeLog.forEach(log => {
						if (log.reviewed_by == 0 && log.time_out != '0000-00-00 00:00:00') {
							if (!("EmployeeSetting" in log.User) || log.User.EmployeeSetting.length == 0 || log.User.EmployeeSetting[0].is_salary == 0) {
								vm.numTimeLogsToReview++
							}
						}
					})
				})

				vm.reviewableLogsFetched = true

			})

		},*/
	},
	created() {
		this.fetchReviewableLogs()
		this.fetchLocateTickets()
		this.fetchArchiveableServices()
		this.fetchArchivableProjects()
		this.fetchIncompleteServices()
		this.fetchVacationRequests()

		this.fetchUnopenedInvoices(true)
		this.fetchCompanyForms()
	}
}
</script>

<style scoped>

.items-grid {
	padding: 10px;
	margin: 0;
}

.items-grid>div {
	width: 50%;
}

.review-item-panel {
	border: 1px solid #e0e0e0;
	padding: 15px;
	padding-top: 10px;
	padding-bottom: 10px;
	color: #50649c;
	display: block;
	width: 100%;
	height: 100%;
}

.review-item-panel:hover {
	text-decoration: none;
	background-color: #e2e5ec;
}

.review-item-panel .total {
	font-size: 26pt;
	font-weight: bold;
}

.review-item-panel h3 {
	font-size: 14pt;
	color: #50649c;
	margin-bottom: 0;
}

@media (max-width: 600px) {
	.items-grid>div {
		width: 100%;
	}
}

</style>